import React, { createContext, FC, useCallback, useState } from 'react';

interface PlayerContextProps {
  data: { time: number };
  setTime: (to: number) => void;
}

export const PlayerContext = createContext<PlayerContextProps>({
  data: { time: 0 },
  setTime: () => {},
});

export const PlayerProvider: FC = ({ children }) => {
  const [data, setData] = useState({ time: 0 });

  const onChangeHandler = useCallback((value) => setData({ time: value }), []);

  return (
    <PlayerContext.Provider value={{ data, setTime: onChangeHandler }}>
      {children}
    </PlayerContext.Provider>
  );
};
